import { render } from "./AlbumForm.vue?vue&type=template&id=3d6dcde4&scoped=true&ts=true"
import script from "./AlbumForm.vue?vue&type=script&lang=ts"
export * from "./AlbumForm.vue?vue&type=script&lang=ts"

import "./AlbumForm.vue?vue&type=style&index=0&id=3d6dcde4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d6dcde4"]])

export default __exports__